const gPermissions = {
    'general_settings':['settings_general_settings','settings_incoming_email','settings_soc','settings_forward_reported_mails','settings_reported_mail_broadcast','settings_smtp','settings_leaderboard_settings'],
    'personalize_settings':['settings_custom_messages','settings_confirmation_message','settings_malicious_alert','settings_reporter_message','settings_mail_header']
    
}


export default function groupPermissions(groupName){
    
    let status = false ; 
    try {
        let user = JSON.parse(localStorage.getItem('user'));
        let permissions = user.permissions 
        for(let i = 0 ; i < gPermissions[groupName].length;i++){
            if (permissions.indexOf(gPermissions[groupName][i]) > -1 ){
                status = true 
                break
            }
        }
        return status ;
    }catch(e){
        // Differentiate a genuine "no user / empty permissions" from a real
        // parse/lookup error (e.g. a mistyped groupName not present in
        // gPermissions, or malformed 'user' JSON). Log so config typos are
        // visible instead of being silently swallowed as no-permission.
        if (gPermissions[groupName] === undefined) {
            console.error('groupPermissions: unknown group name "' + groupName + '" (check gPermissions config)', e)
        } else {
            console.error('groupPermissions: failed to evaluate permissions for "' + groupName + '"', e)
        }
        return false
    }

}



// WEBPACK FOOTER //
// ./src/plugins/grouppermissions.js